import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Text } from 'office-ui-fabric-react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import SubModule from '../SubModule';
import SubModuleHeader from '../SubModuleHeader';
import SubModuleContent from '../SubModuleContent';
import AdvanceGroupAssignmentDetails from '../AdvanceGroupAssignmentDetails';
import FluentGrid from '../FluentGrid';
import styles from './AdvanceGroupCard.style';
import TextButton from '../TextButton';
import { formatNumberWithCommas } from '../../utils';

const AdvanceGroupCard = ({
  advanceGroup,
  openEditPanel,
  enableUpArrow,
  enableDownArrow,
  buttonType,
  upArrowClicked,
  downArrowClicked,
  showOrderingArrows,
  contractCurrency,
}) => {
  const renderAdvanceGroupBalance = balance => {
    const balanceNumber = balance?.toFixed(2) || (0).toFixed(2);
    if (balanceNumber < 0) {
      return (
        <>
          <span className={styles.negativeAmount}>
            {`(${formatNumberWithCommas(balanceNumber)})`}
          </span>
          <span> {contractCurrency}</span>
        </>
      );
    }
    return (
      <span>
        {formatNumberWithCommas(balanceNumber)} {contractCurrency}
      </span>
    );
  };

  return (
    <div className={styles.cardWrapper}>
      <SubModule>
        <SubModuleHeader className={styles.subModuleHeader}>
          {showOrderingArrows && (
            <>
              <IconButton
                iconProps={{
                  iconName: 'Up',
                }}
                disabled={!enableUpArrow}
                onClick={upArrowClicked}
                className={styles.upButton}
                data-testid="advancegroupCardUpArrowButton"
                ariaLabel="Up arrow"
                title="Up arrow"
                tabIndex={0}
              />
              <IconButton
                iconProps={{
                  iconName: 'Down',
                }}
                disabled={!enableDownArrow}
                onClick={downArrowClicked}
                className={styles.downButton}
                data-testid="advancegroupCardDownArrowButton"
                ariaLabel="Down arrow"
                title="Down arrow"
                tabIndex={0}
              />
            </>
          )}

          <Text as="p" data-testid="advanceGroupCardName" className={styles.advanceGroupName}>
            {advanceGroup?.name}
          </Text>
        </SubModuleHeader>
        <SubModuleContent className={styles.noBottomBorder}>
          <FluentGrid>
            <FluentGrid row className={styles.detailsHeader}>
              <FluentGrid col sm={12} md={6}>
                <Text as="p" variant="small">
                  Balance: {renderAdvanceGroupBalance(advanceGroup?.calculatedLiveBalance)}
                </Text>
              </FluentGrid>
              <FluentGrid col sm={12} md={6}>
                <Text variant="small">
                  {' '}
                  Date Created: {moment(advanceGroup?.createdTimestamp).utc().format('MM/DD/YYYY')}
                </Text>
              </FluentGrid>
            </FluentGrid>
          </FluentGrid>
          <br />
          <AdvanceGroupAssignmentDetails groupAssignments={advanceGroup?.groupAssignments} />
          <br />

          <div className={styles.buttonWrapper}>
            {buttonType === AdvanceGroupCard.BUTTON.EDITINPANEL && (
              <TextButton
                className={styles.editAdvanceGroup}
                onClick={() => openEditPanel(advanceGroup)}
              >
                Edit Advance Group Details
              </TextButton>
            )}
            {buttonType === AdvanceGroupCard.BUTTON.VIEWDETAILS && (
              <Link
                className={styles.editAdvanceGroup}
                to={`/advancegroups/${advanceGroup._id}`}
                target="_blank"
              >
                View Advance Group Details
              </Link>
            )}
          </div>
        </SubModuleContent>
      </SubModule>
    </div>
  );
};

AdvanceGroupCard.BUTTON = {
  EDITINPANEL: 'editInPanel',
  VIEWDETAILS: 'viewDetails',
};

AdvanceGroupCard.propTypes = {
  advanceGroup: PropTypes.object.isRequired,
  openEditPanel: PropTypes.func,
  buttonType: PropTypes.oneOf(Object.values(AdvanceGroupCard.BUTTON)).isRequired,
  enableUpArrow: PropTypes.bool.isRequired,
  enableDownArrow: PropTypes.bool.isRequired,
  upArrowClicked: PropTypes.func.isRequired,
  downArrowClicked: PropTypes.func.isRequired,
  showOrderingArrows: PropTypes.bool,
  contractCurrency: PropTypes.string,
};

AdvanceGroupCard.defaultProps = {
  openEditPanel: null,
  showOrderingArrows: false,
  contractCurrency: '',
};

export default AdvanceGroupCard;
